"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
class PageHelper {
    static getOfferUrl() {
        var _a;
        const carDetailElement = document.getElementById('subscription-offer-detail');
        if (carDetailElement) {
            return (_a = carDetailElement.dataset.socialShareOfferLink) !== null && _a !== void 0 ? _a : null;
        }
        return null;
    }
    static getOfferTitle() {
        var _a;
        const carDetailElement = document.getElementById('subscription-offer-detail');
        if (carDetailElement) {
            return (_a = carDetailElement.dataset.socialShareOfferTitle) !== null && _a !== void 0 ? _a : null;
        }
        return null;
    }
}
exports.default = PageHelper;
